import { render, staticRenderFns } from "./FilesViewFileDropEmptyContent.vue?vue&type=template&id=a24d232a&scoped=true"
import script from "./FilesViewFileDropEmptyContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesViewFileDropEmptyContent.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesViewFileDropEmptyContent.vue?vue&type=style&index=0&id=a24d232a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24d232a",
  null
  
)

export default component.exports